// ** React Imports
import { useRef, useEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Third Party Components
import PerfectScrollbarComponent from 'react-perfect-scrollbar'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import CustomAvatar from 'src/@core/components/mui/avatar'

import Image from 'next/image'

import dayjs from 'dayjs'

import { Modal, Spin } from 'antd'

import { useDispatch, useSelector } from 'react-redux'

import { selectMessage, setPerViewImage, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/kik'
import { useTranslation } from 'src/utils/i18n'
import NoData from 'src/components/NoData'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

const AnyReactComponent = ({ text }) => (
  <div className=' '>
    <div className='relative flex '>
      <div className=' absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center  text-center text-[#4d5976] text-opacity-90 font-[500] bg-white  rounded-lg'>
        {text}
      </div>
      <div className='absolute flex items-center justify-center'>
        <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
      </div>
    </div>
  </div>
)

const MessagesLog = props => {
  // ** Props
  const { hidden, advanced } = props
  const { t } = useTranslation('common')

  const data = useSelector(state => state.Kik.selectedMessage)

  const [flag, setFlag] = useState(false)

  // ** Ref
  const chatArea = useRef(null)

  // ** Scroll to chat bottom
  const scrollToBottom = () => {
    if (chatArea.current) {
      if (hidden) {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      } else {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      }
    }
  }

  // 记录首次加载
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (data && data.selected && data.selected.length <= 50) {
      scrollToBottom()
      setIsFirstLoad(false)
    } else {
      if (hidden) {
        // @ts-ignore
        chatArea.current._container.scrollTop = 20
      } else {
        // @ts-ignore

        chatArea.current._container.scrollTop = 20
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ** Renders user chat
  const renderChats = () => {
    if (data.selected.length == 0) {
      if (data.contact.snippet == '') {
        return (
          <div
            style={{
              background: '#F5F5F5',
              fontSize: '26px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#666',
              height: '100%'
            }}
          >
            <NoData />
          </div>
        )
      } else {
        return (
          <div
            style={{
              fontSize: '16px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '10px',
              color: '#666',
              height: '100%',
              padding: '0 10px'
            }}
          >
            <p style={{ fontSize: '13px' }}> {dayjs(data.contact.snippetTimestamp).format('YYYY-MM-DD')}</p>
            <span> {data.contact.snippet}</span>
          </div>
        )
      }
    }

    return data.selected.map((item, index) => {
      const isSender = item.isFromMe

      const time = item.time

      return (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: !item.isFromMe ? 'row' : 'row-reverse'
          }}
        >
          <Box
            className='chat-body'
            sx={{ maxWidth: ['calc(100% - 5.75rem)', '75%', '65%'], minWidth: '74px', position: 'relative' }}
          >
            <Box key={index} sx={{ '&:not(:last-of-type)': { mb: 3.5 } }}>
              <div className=''>
                <Box
                  sx={{
                    boxShadow: 1,
                    borderRadius: 1,
                    maxWidth: '100%',
                    width: 'fit-content',
                    p: theme => theme.spacing(0, 2),
                    ml: isSender ? 'auto' : undefined,
                    borderTopLeftRadius: !isSender ? 0 : undefined,
                    borderTopRightRadius: isSender ? 0 : undefined,
                    color: isSender ? 'black' : 'text.primary',
                    backgroundColor: isSender ? '#D1FAE5' : '#F3F4F6',
                    mb: 4.4,
                    mt: 2
                  }}
                >
                  {(() => {
                    if (typeof item.attachment === 'undefined') {
                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span
                              className='font-semibold text-[0.8rem] text-black text-opacity-80 '
                              style={{ display: 'inline-block', maxWidth: '400px', overflow: 'hidden' }}
                            >
                              {item.text}
                            </span>
                          </div>
                          <div
                            className='absolute  bottom-0 left-0'
                            style={{
                              width: '120px',
                              left: !item.isFromMe ? '0' : 'unset',
                              right: item.isFromMe ? '0' : 'unset'
                            }}
                          >
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    } else if (item.attachment.type === 'video') {
                      let videoUrl =
                        item.attachment.url.substr(0, 4) == 'http'
                          ? item.attachment.url
                          : 'https://cos.spyx.com/' + item.attachment.url

                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>
                              <video
                                controls={true}
                                autoPlay={false}
                                id='video'
                                preload='none'
                                loop={false}
                                muted={false}
                              >
                                {t('can not be used Video')}
                                <source src={videoUrl} type='video/mp4' />
                                <source src='movie.ogg' type='video/ogg' />
                              </video>
                            </span>
                          </div>
                          <div className='absolute  bottom-0 right-0 '>
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    } else if (item.attachment.type === 'photo') {
                      let imgUrl =
                        item.attachment.url.substr(0, 4) == 'http'
                          ? item.attachment.url
                          : 'https://cos.spyx.com/' + item.attachment.url

                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                              <Image
                                src={imgUrl}
                                alt='Picture of the author'
                                width={150}
                                height={150}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  dispatch(
                                    setPerViewImage({
                                      open: true,
                                      url: `${imgUrl}`
                                    })
                                  )
                                }}
                              />
                            </span>
                          </div>
                          <div className='absolute  bottom-0 right-0 '>
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    }
                  })()}
                </Box>
              </div>
            </Box>
          </Box>
        </Box>
      )
    })
  }

  const ScrollWrapper = ({ children }) => {
    if (hidden) {
      return (
        <PerfectScrollbar
          ref={chatArea}
          options={{ wheelPropagation: false }}
          onYReachEnd={container => {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return
            dispatch(selectMessage())
          }}
        >
          {children}

          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}
        </PerfectScrollbar>
      )
    } else {
      return (
        <PerfectScrollbar
          ref={chatArea}
          options={{ wheelPropagation: false }}
          onYReachEnd={container => {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return
            dispatch(selectMessage())
          }}
        >
          {children}

          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}
        </PerfectScrollbar>
      )
    }
  }

  const store = useSelector(state => state.Kik)

  const dispatch = useDispatch()

  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    if (scroll >= 100) {
      if (store.selectedMessage.selected.length >= store.rightTotalCount) return
      dispatch(selectMessage())
      setFlag(true)
      setTimeout(() => {
        setFlag(false)
      }, 1000)
    }
  }, [scroll])

  return (
    <>
      <Box
        sx={{
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px'
        }}
        className={`bg-bgImg h-auto flex-1 ${advanced ? 'overflow-y-auto' : 'overflow-hidden'}`}
      >
        {hidden ? (
          <>
            {advanced ? <PerfectScrollbar
              ref={chatArea}
              options={{ wheelPropagation: false, suppressScrollX: true }}
              onScrollY={(e) => {
                const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                if (!isFirstLoad && progress >= 75) {
                  setScroll(progress)
                }
              }}
            >
              {renderChats()}

              {flag ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Spin />
                </div>
              ) : null}
            </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        ) : (
          <>
            {advanced ? <PerfectScrollbar
              ref={chatArea}
              options={{ wheelPropagation: false }}
              onScrollY={(e) => {
                const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

                if (!isFirstLoad && progress >= 75) {
                  setScroll(progress)
                }
              }}
            >
              {renderChats()}

              {flag ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Spin />
                </div>
              ) : null}
            </PerfectScrollbar>
              :
              renderChats()
            }
          </>
        )}
      </Box>

      <Modal
        title=''
        open={store.preViewImage.open}
        onCancel={() => {
          dispatch(
            setPerViewImage({
              open: false,
              url: ``
            })
          )
        }}
        width='540px'
        footer={[]}
      >
        <div style={{ padding: '14px' }}>
          <Image
            src={store.preViewImage.url}
            width={200}
            height={200}
            style={{ width: '460px', height: 'auto' }}
            alt='preview'
          ></Image>
        </div>
      </Modal>
    </>
  )
}

export default MessagesLog
